"use strict";const _jsxFileName = "/home/runner/work/bloom-mono/bloom-mono/apps/frontend/webChat/src/screens/VideoRooms/List/RoomPreview.tsx";Object.defineProperty(exports, "__esModule", {value: true}); function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }var _react = require('react'); var _react2 = _interopRequireDefault(_react);
var _RoomPreview = require('web/components/VideoRooms/List/RoomPreview'); var _RoomPreview2 = _interopRequireDefault(_RoomPreview);

var _videoRoom = require('web/selectors/videoRoom');
var _hooks = require('web/services/hooks');



// memo keeps connect()'s bailout on unchanged row props (TM-556).
const RoomPreviewContainer = _react.memo.call(void 0, function RoomPreviewContainer ({
  roomKey,
  roomName,
  isActive,
  isArchived,
  onPick,
  onToggleArchivation,
}) {
  const activeParticipantsCount = _hooks.useAppSelector.call(void 0, state =>
    _videoRoom.selectVideoRoomActiveParticipantsCount.call(void 0, state, roomKey))

  return (
    _react2.default.createElement(_RoomPreview2.default, {
      activeParticipantsCount: activeParticipantsCount,
      roomKey: roomKey,
      roomName: roomName,
      isActive: isActive,
      isArchived: isArchived,
      onPick: onPick,
      onToggleArchivation: onToggleArchivation, __self: this, __source: {fileName: _jsxFileName, lineNumber: 22}}
    )
  )
})

exports. default = RoomPreviewContainer
